module.exports = __webpack_public_path__ + "img/m5.88aaf1e8.png";